export default "__VITE_ASSET__DGO5CBPH__"